<div class="modal-overlay" *ngIf="show">
  <div class="create-company-modal">
    <div class="modal-header">
      <h3>Create New Company</h3>
      <i class="bi bi-x close-icon" (click)="onClose()"></i>
    </div>

    <div class="modal-body">
      <label class="company-label">Company Name</label>
      <input type="text" class="company-input" placeholder="Enter company name" [(ngModel)]="name" />

      <label class="company-label">Company Website URL <span>*</span></label>
      <input type="url" class="company-input" placeholder="https://example.com" [(ngModel)]="website" />
    </div>

    <div class="modal-footer">
      <button class="cancel-btn" (click)="onClose()">Cancel</button>
      <button class="save-btn" (click)="onSave()" [disabled]="isSaving">
        <i class="bi bi-arrow-repeat spin" *ngIf="isSaving"></i>
        {{ isSaving ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </div>
</div>